import React from "react";

const Button = ({ className = "", title = "", disabled = false, onClick = () => { } }) => {
    return (
        <button className={"btn " + className} onClick={onClick} disabled={disabled}>
            {title}
        </button>
    )
}

export default Button;